import {
  ContentHomeOverviewQuery,
  SaleState,
  SimpleSeriesSingleInfoQuery,
} from '../graphql/generated/types';

export function selectIsSaleStateIng({
  data,
  productId,
  singleSimpleData,
}: {
  data?: ContentHomeOverviewQuery;
  productId?: number;
  singleSimpleData?: SimpleSeriesSingleInfoQuery;
}) {
  // productId 가 있다면 회차를 쿼리했다는 의미입니다. 회차 쿼리 시 회차의 판매상태, 작품의 판매상태는 모두 singleSimple 에 존재합니다. 둘 모두 판매중일때만 판매중입니다.
  if (singleSimpleData && productId) {
    const singleSaleState =
      singleSimpleData?.simpleSeriesSingleInfo?.singleSaleState;
    const seriesSaleState =
      singleSimpleData?.simpleSeriesSingleInfo?.seriesSaleState;
    return (
      singleSaleState === SaleState.Ing && seriesSaleState === SaleState.Ing
    );
  }

  const seriesSaleState = data?.contentHomeOverview?.content?.saleState;

  return seriesSaleState === SaleState.Ing;
}
